// import PropTypes from 'prop-types';
import React from 'react';
// import { Button } from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import NormalizationContainer from './OldUI/NormalizationContainer';
// import { ViewMode } from '../../constants/dataEnum';
import {changeView} from '../../stores/actions/appStateAction';
import './Normalization.scss';

const mapDispatchToProps = (dispatch) => ({
  appStateActionChangeView: bindActionCreators(changeView, dispatch),
});

function Normalization() {
  // const { appStateActionChangeView } = props;

  // const cancelClick = () => {
  //   appStateActionChangeView(ViewMode.PROTOCOL_EDITOR);
  // };

  return (
    <div className="normalization-container">
      <div className="main">
        <NormalizationContainer />
      </div>
      {/* <div className="footer">
        <div className="button-group">
          <Button className="primary">BACK</Button>
          <Button className="primary" disabled>NEXT</Button>
          <Button className="secondary" onClick={cancelClick}>CANCEL</Button>
        </div>
      </div> */}
    </div>
  );
}

// Normalization.propTypes = {
//   appStateActionChangeView: PropTypes.func.isRequired,
// };

export default connect(null, mapDispatchToProps)(Normalization);
